import { Radio, SxProps, Theme } from '@mui/material';

import { ColorToken } from '../designSystem/colors/colors';
import { CareerTrack } from '../models/careerTrack';
import { CAREER_TRACK_COLORS } from '../utils/careerTrack.util';

type CareerTrackRadioProps = Readonly<{
  careerTrack: CareerTrack['name'];
  width?: number;
}>;

export const CareerTrackRadio = ({ careerTrack, width = 20 }: CareerTrackRadioProps) => {
  const trackColor = CAREER_TRACK_COLORS[careerTrack];

  return <Radio checked sx={radioStyles(trackColor, width)} disabled />;
};

const radioStyles =
  (colorToken: ColorToken, width: number): SxProps<Theme> =>
  ({ backrs }) => ({
    '& .MuiSvgIcon-root': {
      width: `${width}px`,
      height: `${width}px`,
    },
    // Outer ring (always visible)
    '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)': {
      color: 'inherit',
      borderRadius: backrs.radius['radius-full'],
      backgroundColor: backrs.colors[colorToken],
      border: `2px solid ${backrs.colors[colorToken]}`,
      outline: `1px solid ${backrs.colors['Colors/Base/Black']}`,
      boxSizing: 'border-box',
      '& path': {
        fill: backrs.colors[colorToken],
      },
    },
    // Inner dot (checked state)
    '&.Mui-checked .MuiSvgIcon-root + .MuiSvgIcon-root': {
      color: backrs.colors['Colors/Base/White'],
      opacity: 1,
      '& path': {
        fill: backrs.colors['Colors/Base/White'],
        borderRadius: backrs.radius['radius-full'],
        outline: `1px solid ${backrs.colors['Colors/Base/Black']}`,
      },
    },
    p: 0,
    mr: 1,
  });
